import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { DtcAssetDaysTable, type DtcAssetDaysTableHeaderProps } from '../../../../../../../../../../features/dtcc/dtc-asset-day/dtc-asset-days-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsDtcc,
      label: 'DTC Assets',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsDtcc>,
  head: () => getPageHead('DTC Assets'),
  component: DtcAssetsList,
});

function TableHeader({ filter, search }: DtcAssetDaysTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.ClearingOperationsDtcc}
      />

      {search}
    </VerticalStack>
  );
}

function DtcAssetsList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <DtcAssetDaysTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
